import { render, staticRenderFns } from "./columnRiskAddressToolTip.vue?vue&type=template&id=d2777eaa&scoped=true"
import script from "./columnRiskAddressToolTip.vue?vue&type=script&lang=ts"
export * from "./columnRiskAddressToolTip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2777eaa",
  null
  
)

export default component.exports